<div id="lnr-user-main-header">
  <div id="lnr-user-header-icon-area">
    <mat-icon id="lnr-icon-menu" (click)="clickMenu()">menu</mat-icon>
  </div>
  <div id="lnr-name-header">{{pageTitle}}</div>
  <div id="lnr-user-header-photo-area">
    <mat-icon *ngIf="!imgSource" id="lnr-user-header-photo-area-user" [matMenuTriggerFor]="userMenu.menu">account_circle</mat-icon>
    <img *ngIf="imgSource" id="lnr-user-header-photo" [matMenuTriggerFor]="userMenu.menu" src="{{imgSource}}" alt="{{alt}}">
  </div>
</div>
<app-profile-menu #userMenu [profileMenuItems]="profileMenuItems"></app-profile-menu>
